import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDialogViewModel } from 'src/app/components/confirm-dialog/confirm-dialog.view-model';
import { AppNavRouteLink } from 'src/app/shared/commons/AppNavRouteLink';
import { Utils } from 'src/app/shared/commons/Utils';
import { Validations } from 'src/app/shared/commons/Validations';
import { ClientService } from 'src/app/shared/services/client.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { StorageService as storage } from 'src/app/shared/services/storage.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { ZohoService } from 'src/app/shared/services/zoho.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  formLogin: UntypedFormGroup;
  typeInput = 'password';
  iconPassword = 'visibility';
  viewModel: ConfirmDialogViewModel = new ConfirmDialogViewModel();
  storageEvent$: any;
  autocomplete = false
  isProduction: boolean

  constructor(
    private activatedRoute: ActivatedRoute,
    private clientService: ClientService,
    private dialogService: DialogService,
    private formBuilder: UntypedFormBuilder,
    private modalService: BsModalService,
    private router: Router,
    private utilService: UtilService,
    private zohoService: ZohoService
  ) {
    const admin = Boolean(this.activatedRoute.snapshot?.queryParams?.admin)
    if (admin)
      this.isProduction = false
    else
      this.isProduction = this.utilService.functionProtected()
  }

  ngOnInit(): void {
    this.closeAllModals()
    if (this.isProduction) {
      this.formLogin = this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: ['', [Validators.required, Validations.Phone]],
        token: [''],
        email: ['', [Validators.required, Validators.pattern(Utils.getEmailPattern())]],
      })
    } else {
      this.formLogin = this.formBuilder.group({
        login: ['', Validators.required],
        password: ['', [Validators.required, Validations.Password]]
      })
    }
  }

  closeAllModals() {
    this.modalService?.hide()
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i)
    }
  }

  previewPassword() {
    if (this.typeInput === 'password') {
      this.typeInput = 'text';
      this.iconPassword = 'visibility_off';
    } else {
      this.typeInput = 'password';
      this.iconPassword = 'visibility';
    }
  }

  verifyField() {
    if (Utils.unMask(this.f.login.value).length > 10 && Utils.unMask(this.f.login.value).length < 15 && !Validations.CpfOrCnpj(this.f.login)?.invalid) {
      this.formLogin.get('login').setErrors(null)
    } else if (Utils.getEmailPattern().test(this.f.login.value)) {
      this.formLogin.get('login').setErrors(null)
    } else {
      this.formLogin.get('login').setErrors({ invalid: true })
      this.formLogin.get('token').setErrors({ invalid: true })
    }
  }

  login(e: Event) {
    let data = {}
    if (this.formLogin.valid) {
      // document number
      if (Utils.unMask(this.f.login.value).length > 10 && Utils.unMask(this.f.login.value).length < 15) {
        data['document_number'] = Utils.unMask(this.f.login.value);
        // email
      } else if (Utils.getEmailPattern().test(this.f.login.value)) {
        data['email'] = this.f.login.value;
      }

      data['password'] = this.f.password.value

      this.clientService.login(data)
        .then(res => {
          storage.saveClientJwt(res['jwt']);
          storage.saveClientUuid(res['client_uuid']);
          storage.save('is_authenticate', true);

          // expires session
          if ('expires_in' in res) {
            storage.save('session_expires_in', res['expires_in']);
          }

          this.router.navigate([AppNavRouteLink.NAV.DASHBOARD]);
        })
        .catch(err => {
          if (err.status === 400) {
            this.viewModel.subTitle = 'Usuário e/ou senha incorretos.';
            this.dialogService.showDialogTryAgain(this.viewModel);
          } else {
            this.dialogService.showDialogError('Serviço temporariamente indisponível. Tente novamente mais tarde.');
          }
        })
    } else {
      this.formLogin.markAllAsTouched()
    }
  }

  async zohoSend() {
    const tokenControl = this.formLogin.get('token')
    tokenControl?.setErrors({ invalid: true })

    const otherControlsValid = Object.entries(this.formLogin.controls)
      .filter(([key]) => key !== 'token')
      .every(([, control]) => control.valid);

    if (!otherControlsValid) {
      this.formLogin.markAllAsTouched()
      return
    }

    const body = this.formLogin.getRawValue()
    const $res = await this.zohoService.enviar(body)
    if (!$res) return;
    window.location.href = $res
  }

  onForgotPassword() {
    this.router.navigate([AppNavRouteLink.PAGE.FORGOT_PASSWORD])
  }

  onOpenAccount(): void {
    this.router.navigate([AppNavRouteLink.NAV.OPEN_ACCOUNT]);
  }

  back() {
    this.clientService.redirectLandingPage()
  }

  // convenience getter for easy access to form fields
  get f() { return this.formLogin.controls; }
}
